
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";

import ProgressBarPercentage from "../components/ProgressBarPercentage";

const ProfileReadiness = () =>{
    
    return(
        <div className="card">
            <div className="card-header">
                <h5>Profile Readiness</h5>
            </div>
            <div className="card-block">
                <div className="table-resposive">
                    <table className="table table-bordered">
                        <tr>
                            <td><FontAwesomeIcon icon={faPen} className="icon d-inline-block align-middle" /> Contact Details</td>
                            <td>
                                <ProgressBarPercentage />
                            </td>
                        </tr>
                        <tr>
                            <td><FontAwesomeIcon icon={faPen} className="icon d-inline-block align-middle" /> Personal Details</td>
                            <td>
                                <ProgressBarPercentage />
                            </td>
                        </tr>
                        <tr>
                            <td><FontAwesomeIcon icon={faPen} className="icon d-inline-block align-middle" /> Dependents</td>
                            <td>
                                <ProgressBarPercentage />
                            </td>
                        </tr>
                        <tr>
                            <td><FontAwesomeIcon icon={faPen} className="icon d-inline-block align-middle" /> Current Employment</td>
                            <td>
                                <ProgressBarPercentage />
                            </td>
                        </tr>
                        <tr>
                            <td><FontAwesomeIcon icon={faPen} className="icon d-inline-block align-middle" /> Awards and Accolades</td>
                            <td>
                                <ProgressBarPercentage />
                            </td>
                        </tr>
                        <tr>
                            <td><FontAwesomeIcon icon={faPen} className="icon d-inline-block align-middle" /> HR Details</td>
                            <td>
                                <ProgressBarPercentage />
                            </td>
                        </tr>
                        <tr>
                            <td><FontAwesomeIcon icon={faPen} className="icon d-inline-block align-middle" /> Skills</td>
                            <td>
                                <ProgressBarPercentage />
                            </td>
                        </tr>
                        <tr>
                            <td><FontAwesomeIcon icon={faPen} className="icon d-inline-block align-middle" /> Work Experiences</td>
                            <td>
                                <ProgressBarPercentage />
                            </td>
                        </tr>
                        <tr>
                            <td><FontAwesomeIcon icon={faPen} className="icon d-inline-block align-middle" /> Education Details</td>
                            <td>
                                <ProgressBarPercentage />
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    );
}


export default ProfileReadiness;